import { useMutation } from "@apollo/client/react";
import { useNotificationState } from "hooks/state";
import flatten from "lodash/flatten";
import values from "lodash/values";
import GqlError from "utils/GqlError";
import { UpdateLayoutSetting } from "./customerSettings.gql";

export default function useUpdateCustomerSettings({ onCompleted }) {
  const { setNotification } = useNotificationState();
  const [updateCustomerSettings] = useMutation(UpdateLayoutSetting, {
    onCompleted,
    onError: (error) => {
      GqlError.handler(error, (errors) => {
        const allErrors = flatten(values(errors)).join("\n");

        setNotification({
          message: allErrors,
          title: "Unable to update layout settings",
          type: "danger",
        });
      });
    },
  });

  return (customerSettings) => {
    const { workBlockLayout, workOrderCardLayout } = customerSettings;

    const { __typename, ...layoutProps } = workOrderCardLayout;

    return updateCustomerSettings({
      variables: {
        workBlockLayout,
        ...layoutProps,
      },
    });
  };
}
